<div class="wrapper flex column">
  <mat-divider class="divider"></mat-divider>

  <div class="content">
    <form class="form-group flex column justify-flex-start align-flex-start" [formGroup]="form">
      <!-- affective date -->
      <div class="flex column form-control">
        <app-date-input
          (changeEvent)="onAffectiveDateChange($event)"
          formControlName="affectiveDate"
          [title]="'Inputs.AffectiveDate' | translate"
          [min]="minAffectiveDate"
          [required]="true"
        ></app-date-input>
      </div>

      <!-- expiry date -->
      <div class="flex column form-control">
        <app-date-input
          formControlName="expiryDate"
          [title]="'Inputs.ExpireDate' | translate"
          [min]="minExpiryDate"
          [required]="true"
          [disabled]="!form.value['affectiveDate']"
        ></app-date-input>
      </div>
    </form>
  </div>

  <mat-divider class="divider"></mat-divider>

  <div class="action flex">
    <button mat-raised-button class="btn-secondary btn" (click)="onCancelClicked()">{{ "Buttons.Cancel" | translate }}</button>

    <button [disabled]="form.invalid" mat-raised-button class="btn-primary btn" (click)="onConfirmClicked()">
      {{ "Buttons.Confirm" | translate }}
    </button>
  </div>
</div>
